import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "envelope",
  "use": "envelope-usage",
  "viewBox": "0 0 448 448",
  "content": "<symbol viewBox=\"0 0 448 448\" id=\"envelope\"><path d=\"M448 177.5V376c0 22-18 40-40 40H40c-22 0-40-18-40-40V177.5c7.5 8.25 16 15.5 25.25 21.75 41.5 28.25 83.5 56.5 124.25 86.25 21 15.5 47 34.5 74.25 34.5h.5c27.25 0 53.25-19 74.25-34.5 40.75-29.5 82.75-58 124.5-86.25 9-6.25 17.5-13.5 25-21.75zm0-73.5c0 28-20.75 53.25-42.75 68.5-39 27-78.25 54-117 81.25C272 265 244.5 288 224.25 288h-.5c-20.25 0-47.75-23-64-34.25C121 226.5 81.75 199.5 43 172.5c-17.75-12-43-40.25-43-63C0 85 13.25 64 40 64h368c21.75 0 40 18 40 40z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/envelope.svg
// module id = m4SL
// module chunks = 1